import React from "react";
import "../../style/main.scss";
const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <div className="footerWrapper">
          <div className="footer-col-1">
            <img
              className="footerLogo"
              src="/images/home/footerLogo.png"
              alt="..."
            />
            <p className="footer-para">
              {/* Streamlining Customer Interactions, Appointment Scheduling, and
              Contracts for Real Estate and Legal Professionals */}
              Group LanDev AI revolutionizes customer interactions, simplifying
              the process of scheduling appointments and streamlining contract
              procedures, leaving behind a stage of construction where the
              experience is nothing short of a creative masterpiece.
            </p>
            <div className="social-media-wrapper">
              <img src="/images/home/discord.png" alt="..." />
              <img src="/images/home/insta.png" alt="..." />
              <img src="/images/home/facebook-footer.png" alt="..." />
              <img src="/images/home/twittter-footer.png" alt="..." />
            </div>
          </div>
          <div className="footer-col-2">
            <h5>Explore</h5>
            <a>About</a>
            <a href="#contact">Contact</a>
            <a href="#blog">Blog</a>
            <a>Affiliate</a>
          </div>
          {/* <div className="footer-col-3">
            <h5>Product</h5>
            <a>Tags</a>
            <a>API</a>
            <a>FAQ</a>
          </div> */}
          <div className="footer-col-3">
            <h5>Pages</h5>
            <a>Community</a>
            <a>Support</a>
            <a>Terms of Services</a>
          </div>
          <div className="footer-col-4">
            <a href="#scrollTop">
              <button style={{ border: "none" }}>
                <img
                  className="footer-arrow-up"
                  src="/images/home/footerArrowUp.png"
                  alt="..."
                />
              </button>
            </a>
          </div>
        </div>
        <hr />
        <p className="allRights">@2023 Legal AI Agent. All Rights Reserved</p>
      </div>
    </>
  );
};

export default Footer;
